import { ClubHome } from './ClubHome';

export default ClubHome;
